import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { User } from 'src/app/shared/models/security/user';

@Injectable({
	providedIn: 'root'
})
export class EmployeeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	employeeIsyUrl = `https://pvyv02.isycare-technology.com/affectation/employee/ocashe`;

	/**
	 * Récupère tout les employees actifs
	 * @returns
	 */
	getAllActiveEmployees(): Observable<Employee[]> {
		// let queryParams = new HttpParams();
		// queryParams = queryParams.append('active', true);

		// const httpOptions = {
		// 	params: queryParams
		// };

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/all`,
			'getAllEmployees',
			//httpOptions
		);
	}

	/**
	 * Récupère tout les employee qui ne sont pas absents et pas indisponibles
	 * @returns
	 */
	getAllEmployeesAvailable(
		date: Date,
		startTime: number,
		endTime: number
	): Observable<Employee[]> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('active', true);
		queryParams = queryParams.append('availabilityDate', date.getTime());
		queryParams = queryParams.append('availabilityStart', startTime);
		queryParams = queryParams.append('availabilityEnd', endTime);

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}`,
			'getAllEmployeesAvailable',
			httpOptions
		);
	}

	/**
	 * Récupère un employée en fonction de son id
	 * @param empId
	 * @returns
	 */
	getEmployeeById(empId: number): Observable<Employee> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/get/${empId}`,
			'getEmployeeById'
		);
	}

	getEmployeeByMissionRequestId(missionRqId: number): Observable<Employee> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/missionRequest/${missionRqId}`,
			'getEmployeeByMissionRequestId'
		);
	}

	importEmployees(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'employees.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeeUrl}/import`,
			`importEmployees`,
			formData
		);
	}

	/**
	 * Met à jour un employee
	 * @param employee
	 * @returns
	 */
	updateEmployee(employee: Employee): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.employeeUrl}/update/${employee.id}`,
			`updateEmployee`,
			employee
		);
	}

	/**
	 * Sauvegarde un employee
	 * @param employee
	 * @returns
	 */
	addEmployee(employee: Employee): Observable<Employee> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeeUrl}/add`,
			`addEmployee`,
			employee
		);
	}

	/**
	 * Supprime un employee
	 * @param empId id de l'employee
	 * @returns
	 */
	deleteEmployee(empId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.employeeUrl}/delete/${empId}`,
			`deleteEmployee`
		);
	}

	addEmployeeIsy(employee: Employee): Observable<number> {
		return this.genericCrudService.genericPostDataToAPI(
					`${this.employeeIsyUrl}/post`,
					`addEmployeeIsy`,
					employee
				);
		
	}

	updateEmployeeIsy(employee: Employee): Observable<string> {
		return this.genericCrudService.genericPostDataToAPI(
					`${this.employeeIsyUrl}/put`,
					`updateEmployeeIsy`,
					employee
				);
		
	}

	deleteEmployeeIsy(employeeId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.employeeIsyUrl}/delete/${employeeId}`,
			`deleteEmployee`
		);
	}

	changePassword(user: User): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.employeeUrl}/changePassword/${user.id}`,
			`updateUser`,
			user
		);
	}
}
